import React, { useContext } from "react";
import { PageHeader, Spin } from "antd";
import { LanguageContext } from "../../context/LanguageContext";
import _ from "lodash";
import "../viewFormModel.css";
import moment from "moment";
export const ViewPrevetiveDetails = ({
  dataStates,
  name,
  preventiveAction,
  loading,
}) => {
  console.log("professionals", dataStates);
  console.log("preventiveAction", preventiveAction);
  const { language, setLanguage, t } = useContext(LanguageContext);
  const getPreventiveName = (id) => {
    console.log("id", id);
    const preventiveActions = preventiveAction || [];

    if (preventiveActions.length > 0) {
      const action = _.find(preventiveActions, (o) => o.id === Number(id));
      return action ? action.name : null;
    }

    return null;
  };

  return loading ? (
    <div
      style={{
        minHeight: 200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spin size="large" />
    </div>
  ) : (
    <>
      <PageHeader
        ghost={false}
        onBack={false}
        title={t("name_of_the_accused")}
        subTitle={[
          <span
            style={{
              fontSize: "20px",
              color: "black",
              fontWeight: "600",
            }}
          >
            {":"} {name}
          </span>,
        ]}
      ></PageHeader>
      <PageHeader ghost={false} onBack={false}>
        {dataStates && dataStates.length > 0 && (
          <div className="ant-table-wrapper" style={{ overflowX: "auto" }}>
            <table
              className="ant-table ant-table-bordered"
              style={{ border: "1px solid rgb(26, 20, 20)", width: "100%" }}
            >
              <thead className="ant-table-thead">
                <tr>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("sr.no")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("preventive_action_name")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("date_from")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("date_to")}
                  </th>
                </tr>
              </thead>
              <tbody className="ant-table-tbody">
                {dataStates.length > 0 &&
                  dataStates.map((data, index) => (
                    <tr key={index}>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {index + 1}
                      </td>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {getPreventiveName(parseInt(data.preventive_action))}
                      </td>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {moment(data.date_from).format("DD-MM-YYYY")}
                      </td>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {moment(data.date_to).format("DD-MM-YYYY")}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </PageHeader>
    </>
  );
};
